import React from "react";

import "./loader.css";

export default function Loader(props) {
  return (
    <div className={`loader-ring ${props.className || ''}`}>
      <div/>
      <div/>
      <div/>
      <div/>
    </div>
  )
}
